import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Gallery } from "@/components/Gallery";
import { Equipment } from "@/components/Equipment";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App bg-[#FAFAFA] text-neutral-900 font-body">
      <Toaster position="top-center" theme="dark" />
      <Navbar />
      <main>
        <Hero />
        <Gallery />
        <Equipment />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
